import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './HeroSlider.css';

// Import de l'image locale du directeur
// NOTE : Assurez-vous que le fichier s'appelle bien "ditecteur.jpeg" dans le dossier assets
import directeurBg from '../assets/ditecteur.jpeg';
import conseilBG from '../assets/conseil_image.png';
import expertiseBG from '../assets/expertise_image.png';

const slides = [
  {
    id: 1,
    subtitle: "ATAA REALTY",
    title: "Votre Avenir Immobilier,\nNotre Priorité",
    desc: "Fournir les meilleurs services d'expertise , de conseil et de formation en immobilier",
    btnText: "EN SAVOIR PLUS",
    bgImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: 2,
    subtitle: "MEILLEURE PRISE DE DÉCISION",
    title: "EXPERTISE \n IMMOBILIÈRE",
    desc: "Des expertises en évaluation immobilière aux standards nationaux et internationaux",
    btnText: "JE DÉCOUVRE L'EXPERTISE",
    bgImage: expertiseBG
  },
  {
    id: 3,
    subtitle: "STRATÉGIE GAGNANTE",
    title: "CONSEIL \nSTRATÉGIQUE",
    desc: "Un accompagnement sur mesure pour optimiser, sécuriser et renforcer vos investissements immobiliers",
    btnText: "ATAA CONSULTING",
    bgImage: conseilBG
  },
  {
    id: 4,
    subtitle: "VISION CLAIRE",
    title: "ÉTUDES \nIMMOBILIÈRES",
    desc: "Anticiper les tendances grâce à nos études de marché, alliant force de terrain aux connaissances multidisciplinaires",
    btnText: "ÉTUDES ATAA",
    bgImage: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop"
  },
  {
    id: 5,
    subtitle: "MONTÉE EN COMPÉTENCE",
    title: "FORMATION \nPROFESSIONNELLE",
    desc: "Des interventions de formation adaptées à vos besoins de maîtrise en immobilier",
    btnText: "FORMATIONS ATAA",
    bgImage: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: 6,
    subtitle: "VOTRE PROJET",
    title: "JE FORMULE \nUNE DEMANDE",
    desc: "Vous avez un projet spécifique ? Contactez nos experts pour une solution dédiée.",
    btnText: "NOUS CONTACTER",
    bgImage: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=2070&auto=format&fit=crop"
  },
  {
    id: 7,
    subtitle: "LEADERSHIP & VISION",
    title: "NOTRE \nDIRECTEUR",
    desc: "L'excellence et l'innovation au cœur de notre stratégie pour bâtir votre avenir immobilier.",
    btnText: "MOT DU DIRECTEUR",
    bgImage: directeurBg 
  }
];

const HeroSlider = () => {
  return (
    <div className="hero-section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        effect={'fade'}
        speed={1000}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        navigation={true}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-content" style={{ backgroundImage: `url(${slide.bgImage})` }}>
              <div className="overlay"></div>
              <div className="container slide-text-container">
                <div className="text-box">
                  <h3 className="anim-subtitle">{slide.subtitle}</h3>
                  <h1 className="anim-title">
                    {slide.title.split('\n').map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </h1>
                  <p className="anim-desc">{slide.desc}</p>
                  <button className="hero-btn anim-btn">{slide.btnText}</button>
                </div>
                {/* Suppression de la div image-box ici */}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;